import { Link } from "react-router-dom";
import { flashes, hotSearch } from "@/mocks/news";

const hotLink: Record<string, string> = {
  总决赛压哨绝杀: "/news/bl-2305",
  平台分成新规: "/news/bl-2401",
  素人综艺出圈: "/news/bl-2302",
  以旧换新细则: "/news/bl-2312",
  暴雨救援进行时: "/news/bl-2304",
  折叠屏轻薄之战: "/news/bl-2315",
  博物馆夜游: "/news/bl-2306",
  国产大模型新版: "/news/bl-2307",
};

const tagColor: Record<string, string> = {
  爆: "bg-primary-600 text-background-50",
  热: "bg-accent-500 text-foreground-950",
  新: "bg-secondary-500 text-background-50",
  荐: "bg-background-200 text-foreground-600",
  趣: "bg-primary-100 text-primary-800",
};

export default function HotTopic() {
  return (
    <section className="bg-background-50 py-10 md:py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* 今日热搜 */}
          <div className="bg-background-100 border border-background-200 rounded-xl p-5 md:p-6">
            <div className="flex items-center justify-between mb-5">
              <h2 className="font-heading text-lg font-black text-foreground-950 flex items-center gap-2">
                <i className="ri-fire-fill text-primary-600 text-xl"></i>今日热搜话题
              </h2>
              <span className="text-xs text-foreground-400">实时更新 · {hotSearch.length} 个话题</span>
            </div>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2">
              {hotSearch.map((h) => (
                <li key={h.rank}>
                  <Link
                    to={hotLink[h.keyword] || "/"}
                    className="group flex items-center gap-3 py-2.5 border-b border-background-200/60 hover:border-primary-300 transition-colors"
                  >
                    <span className="font-heading text-xl font-black text-foreground-300 group-hover:text-primary-500 transition-colors w-6 flex-shrink-0">
                      {String(h.rank).padStart(2, "0")}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block text-sm font-medium text-foreground-800 truncate group-hover:text-primary-700 transition-colors">
                        {h.keyword}
                      </span>
                      <span className="text-xs text-foreground-400">{h.count}</span>
                    </span>
                    <span className={`w-7 h-7 flex items-center justify-center rounded text-xs font-bold flex-shrink-0 ${tagColor[h.tag] || "bg-background-200 text-foreground-600"}`}>
                      {h.tag}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 刚刚 · 快讯流 */}
          <div className="relative overflow-hidden rounded-xl">
            <div className="bg-foreground-950 rounded-xl p-5 md:p-6 h-full">
              <div className="flex items-center justify-between mb-5">
                <h2 className="font-heading text-lg font-black text-background-50 flex items-center gap-2">
                  <span className="relative flex w-2.5 h-2.5">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent-400 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-accent-500"></span>
                  </span>
                  刚刚 · 快讯流
                </h2>
                <span className="text-xs text-background-300/70 flex items-center gap-1">
                  <i className="ri-refresh-line"></i>实时滚动
                </span>
              </div>
              <ul className="space-y-0">
                {flashes.map((f, i) => (
                  <li key={i} className="relative flex gap-4 py-3">
                    {i < flashes.length - 1 && (
                      <span className="absolute left-[6px] top-8 bottom-0 w-px bg-background-100/15"></span>
                    )}
                    <span className="mt-1.5 w-[13px] h-[13px] rounded-full border-2 border-accent-400 bg-foreground-950 flex-shrink-0 z-10"></span>
                    <div className="min-w-0">
                      <div className="flex items-center gap-2 text-xs text-background-300/70 mb-1">
                        <span className="font-mono">{f.time}</span>
                        <span className="px-1.5 py-0.5 rounded-sm bg-accent-500/20 text-accent-300 text-[11px]">{f.tag}</span>
                      </div>
                      <p className="text-sm text-background-100/90 leading-relaxed">{f.text}</p>
                    </div>
                  </li>
                ))}
              </ul>
              <Link
                to="/category/shehui"
                className="mt-3 inline-flex items-center gap-1 text-sm text-accent-300 hover:text-accent-200 font-medium"
              >
                查看更多现场快讯<i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}